<main class="login-page">
  <div class="login-card-wrap">

    <!-- Brand -->
    <div class="login-brand">
      <span class="login-brand-tile" aria-hidden="true">
        <ui-icon name="package" [size]="26"></ui-icon>
      </span>
      <h1 class="login-brand-name">Repair Asset Management</h1>
      <p class="login-brand-sub">Sign in to your warehouse account</p>
    </div>

    <!-- Login card -->
    <section class="login-card" aria-label="Sign in">
      <form (ngSubmit)="onLogin()" #loginForm="ngForm" novalidate>

        <div class="login-field">
          <label for="email" class="form-label">Email address</label>
          <input
            id="email"
            type="email"
            name="email"
            class="form-control"
            [class.is-invalid]="emailField.invalid && emailField.touched"
            [(ngModel)]="email"
            required
            email
            autocomplete="username"
            #emailField="ngModel"
            (input)="onInputChange()">
          <p *ngIf="emailField.invalid && emailField.touched" class="field-error" role="alert">
            Enter the email address you use for this system, like name&#64;company.com.
          </p>
        </div>

        <div class="login-field">
          <label for="password" class="form-label">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            class="form-control"
            [class.is-invalid]="passwordField.invalid && passwordField.touched"
            [(ngModel)]="password"
            required
            autocomplete="current-password"
            #passwordField="ngModel"
            (input)="onInputChange()">
          <p *ngIf="passwordField.invalid && passwordField.touched" class="field-error" role="alert">
            Enter your password to sign in.
          </p>
        </div>

        <!-- Sign-in error: what happened + what to do next -->
        <div *ngIf="errorMessage" class="login-error" role="alert">
          <ui-icon name="alert-circle" [size]="18" class="login-error-icon" aria-hidden="true"></ui-icon>
          <div>
            <p class="login-error-title">Could not sign you in</p>
            <p class="login-error-text">{{ errorMessage }}</p>
            <p *ngIf="errorMessage.includes('Invalid email or password')" class="login-error-hint">
              Check the spelling of your email and remember the password is case-sensitive.
            </p>
            <p *ngIf="errorMessage.includes('connect') || errorMessage.includes('timed out')" class="login-error-hint">
              Check your network connection, then try again.
            </p>
            <p *ngIf="errorMessage.includes('Too many')" class="login-error-hint">
              Wait a few minutes before trying again, or ask your administrator for help.
            </p>
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-lg w-100 login-submit"
          [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ isLoading ? 'Signing in…' : 'Sign in' }}
        </button>
      </form>
    </section>

    <p class="login-footer">Need an account? Ask your administrator to set one up.</p>
  </div>
</main>
